import { createUserManager, logoutRedirect, setUserManager } from '@services/auth/AuthService';
import { useEffect, useState } from 'react';
import { timer_worker } from './timer_worker.js';

let timerWorker: Worker;

export const useTimer = (timerLimit) => {
  const [webWorkerTime, setWebWorkerTime] = useState(0);
  const [timeLimit, setTimeLimit] = useState<number>(timerLimit);
  const [timeout, setTimeout] = useState(false);

  useEffect(() => {
    const startTime = localStorage.getItem('timerStart');
    const currentTime = new Date().getTime();

    if (startTime !== null && currentTime - Number(startTime) > timerLimit * 1000) {
      setTimeout(true);
      localStorage.removeItem('timerStart');
      const userManager = createUserManager();
      setUserManager(userManager);
      logoutRedirect();
    }

    timerWorker = new Worker(timer_worker); // Initialize inside useEffect

    timerWorker.onmessage = ({ data: { time } }) => {
      if (localStorage.getItem('ipAuthorized') === 'false') {
        localStorage.removeItem('timerStart');
      }

      const startTime = localStorage.getItem('timerStart');
      const currentTime = new Date().getTime();

      if (
        time / 10 >= timeLimit ||
        (startTime !== null && currentTime - Number(startTime) > timeLimit * 1000)
      ) {
        localStorage.removeItem('timerStart');
        setTimeout(true);
        resetTimer();
      } else {
        setWebWorkerTime(time);
      }
    };

    return () => {
      clearInterval(keepAliveInterval);
      timerWorker.terminate();
    };
  }, [timeLimit]);

  const startTimer = () => {
    localStorage.setItem('timerStart', new Date().getTime().toString());
    timerWorker.postMessage({ type: 'START' });
  };

  const resetTimer = () => {
    timerWorker.postMessage({ type: 'RESET' });
    setWebWorkerTime(0);
    setTimeout(false);
  };

  // Keep the web worker alive
  const keepAliveInterval = setInterval(() => {
    timerWorker.postMessage({ type: 'KEEP_ALIVE' });
  }, 10000); // Send a message every 10 seconds

  return {
    webWorkerTime,
    timeout,
    setTimeLimit,
    startTimer,
    resetTimer,
  };
};
